import _classCallCheck from '../../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../../@babel/runtime/helpers/esm/createClass.js';
import _possibleConstructorReturn from '../../@babel/runtime/helpers/esm/possibleConstructorReturn.js';
import _getPrototypeOf from '../../@babel/runtime/helpers/esm/getPrototypeOf.js';
import _inherits from '../../@babel/runtime/helpers/esm/inherits.js';
import { nothing as A, noChange as T } from '../lit-html.js';
import { directive as e$1, PartType as t, Directive as i } from '../directive.js';

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var e = /*#__PURE__*/function (_r) {
  _inherits(e, _r);
  function e(i) {
    var _this;
    _classCallCheck(this, e);
    if (_this = _callSuper(this, e, [i]), _this.et = A, i.type !== t.CHILD) throw Error(_this.constructor.directiveName + "() can only be used in child bindings");
    return _possibleConstructorReturn(_this);
  }
  _createClass(e, [{
    key: "render",
    value: function render(r) {
      if (r === A || null == r) return this.ft = void 0, this.et = r;
      if (r === T) return r;
      if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
      if (r === this.et) return this.ft;
      this.et = r;
      var s = [r];
      return s.raw = s, this.ft = {
        _$litType$: this.constructor.resultType,
        strings: s,
        values: []
      };
    }
  }]);
  return e;
}(i);
e.directiveName = "unsafeHTML", e.resultType = 1;
var o = e$1(e);

export { e as UnsafeHTMLDirective, o as unsafeHTML };
